import { queryOptions } from '@tanstack/react-query';
import { alertQueryFunction } from '@/modules/FileDetail/queries/alerts/alertsQueryFunction.ts';

export const alertsQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ['get_alerts', id],
    queryFn: () => alertQueryFunction(id),
    enabled: !!id,
  });
